import { existsSync } from 'fs';
import { join } from 'path';
import type { FrameworkInfo } from './framework-detector';

export interface LayoutInfo {
  path: string;
  exists: boolean;
  isTypeScript: boolean;
  isAppRouter: boolean;
}

/**
 * Detects the layout file for the current Next.js project
 */
export async function detectLayoutFile(
  framework: FrameworkInfo,
  projectRoot: string = process.cwd()
): Promise<LayoutInfo> {
  if (framework.isAppRouter) {
    // Check for layout files in order of preference
    const candidates = [
      'app/layout.tsx',
      'app/layout.jsx',
      'app/layout.js',
      'src/app/layout.tsx',
      'src/app/layout.jsx',
      'src/app/layout.js',
    ];
    
    for (const candidate of candidates) {
      const fullPath = join(projectRoot, candidate);
      if (existsSync(fullPath)) {
        return {
          path: candidate,
          exists: true,
          isTypeScript: candidate.endsWith('.tsx'),
          isAppRouter: true,
        };
      }
    }
    
    // Create default if none exists
    const defaultPath = framework.hasSrcDir ? 'src/app/layout.tsx' : 'app/layout.tsx';
    return {
      path: defaultPath,
      exists: false,
      isTypeScript: framework.hasTypeScript !== false,
      isAppRouter: true,
    };
  } else {
    // Pages Router
    const candidates = [
      'pages/_app.tsx',
      'pages/_app.jsx',
      'pages/_app.js',
      'src/pages/_app.tsx',
      'src/pages/_app.jsx',
      'src/pages/_app.js',
    ];
    
    for (const candidate of candidates) {
      const fullPath = join(projectRoot, candidate);
      if (existsSync(fullPath)) {
        return {
          path: candidate,
          exists: true,
          isTypeScript: candidate.endsWith('.tsx'),
          isAppRouter: false,
        };
      }
    }
    
    // Create default if none exists
    const defaultPath = framework.hasSrcDir ? 'src/pages/_app.tsx' : 'pages/_app.tsx';
    return {
      path: defaultPath,
      exists: false,
      isTypeScript: framework.hasTypeScript !== false,
      isAppRouter: false,
    };
  }
}

/**
 * Check if a file already has Vibeship provider imported
 */
export function hasVibeshipProvider(content: string): boolean {
  return content.includes('@vibeship/devtools') || 
         content.includes('VibeshipProvider') ||
         // Also check for old name for backwards compatibility
         content.includes('VibecodeProvider');
}